import { jsx as _jsx } from "react/jsx-runtime";
import { Icon, mode, useColorMode } from '@abb/uikit';
import React from 'react';
const Contrast02 = ()=>{
    const { colorMode } = useColorMode();
    return /*#__PURE__*/ _jsx(Icon, {
        width: "20px",
        height: "20px",
        viewBox: "0 0 20 20",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ _jsx("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M9.99992 2.49992C5.85778 2.49992 2.49992 5.85778 2.49992 9.99992C2.49992 14.1421 5.85778 17.4999 9.99992 17.4999C14.1421 17.4999 17.4999 14.1421 17.4999 9.99992C17.4999 5.85778 14.1421 2.49992 9.99992 2.49992ZM0.833252 9.99992C0.833252 4.93731 4.93731 0.833252 9.99992 0.833252C15.0625 0.833252 19.1666 4.93731 19.1666 9.99992C19.1666 15.0625 15.0625 19.1666 9.99992 19.1666C4.93731 19.1666 0.833252 15.0625 0.833252 9.99992ZM9.16659 4.58325C9.16659 4.12301 9.53968 3.74992 9.99992 3.74992C13.4517 3.74992 16.2499 6.54814 16.2499 9.99992C16.2499 13.4517 13.4517 16.2499 9.99992 16.2499C9.53968 16.2499 9.16659 15.8768 9.16659 15.4166V4.58325Z",
            fill: mode('black', 'white')({
                colorMode
            })
        })
    });
};
export default Contrast02;
